import axios from 'axios';

export default axios.create({
    baseURL: 'https://stepupkorea.kr/'
});

export const axiosPrivate = axios.create({
    baseURL: "https://stepupkorea.kr/",
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
